import $ from "jquery";
window.$ = window.jQuery = $;
import "slick-carousel";
import * as parallax from "./parallax";
import "./tools";
import "./tabs";
import "./utm_params";
import "@fortawesome/fontawesome-free/js/fontawesome.js";
import "@fortawesome/fontawesome-free/js/solid.js";
import { createChat } from '@n8n/chat';

$(document).ready(function() {

	// HTML transforms
    $('.doc table').each(function() {
    	$(this).wrap('<div class="table-wrapper">');
    });
	$(document).on('click', 'figure.can-fullscreen', function() {
		$(this).toggleClass('is-fullscreen');
	});

	// Scroll animation effects
    parallax.init();

	// n8n Chat
	let i18n;
	let initialMessages;
	if (document.documentElement.lang === 'de') {
		i18n = {
			en: {
				title: 'DeepL for Salesforce Chat',
				subtitle: '',
				footer: '',
				getStarted: 'Klicke hier, um unsere Datenschutzbestimmungen zu akzeptieren. Wir nutzen KI, um Deine Fragen zu beantworten.',
				inputPlaceholder: 'Gib deine Frage ein..',
			},
		};
		initialMessages = ['👋 Hallo! Wie können wir Dir helfen?'];
	} else {
		i18n = {
			en: {
				title: 'DeepL for Salesforce',
				subtitle: '',
				footer: '',
				getStarted: 'Click here to accept our privacy policy. We use AI to answer your questions.',
				inputPlaceholder: 'Type your question..',
			},
		};
		initialMessages = ['👋 Hello! How can we assist you?'];
	}
	createChat({
		webhookUrl: 'https://cloudworx.app.n8n.cloud/webhook/4aaac05d-418e-4927-a97a-584a98e571f9/chat',
		showWelcomeScreen: true,
		defaultLanguage: 'en',
		i18n: i18n,
		initialMessages: initialMessages,
		metadata: {
			initialLanguage: document.documentElement.lang,
			pageUrl: window.location.href,
			pageDomain: window.location.hostname,
		}
	});

	// Sliders
	$('.slick').each(function() {
		const slider = $(this);
		slider.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: slider.siblings('.slick-arrow-left'),
			nextArrow: slider.siblings('.slick-arrow-right'),
			draggable: true,
			speed: 750,
			autoplaySpeed: 5000
		});
	});

	// override smooth scrolling on load
	const hash = window.location.hash;
	if (hash) {
		const element = document.getElementById(hash.slice(1));
		if (element) {
			const offsetTop = element.offsetTop;
			window.scrollTo({
				top: offsetTop,
				behavior: 'instant'
			});
		}
	}

	// Mobile navigation
	$('.nav-burger').on('click', function(e) {
		e.preventDefault();
		$(this).parents('.nav').toggleClass('nav--opened');
	});
	$('.nav-item a').on('click', function(e) {
		const navitem = $(this);
		const subnav = navitem.siblings('.nav-subitems');
		if (subnav.length && $('.nav-burger').is(':visible')) {
			e.preventDefault();
			if (subnav.is(':visible')) {
				navitem.removeClass('active');
				subnav.slideUp();
			} else {
				navitem.addClass('active');
				subnav.slideDown();
			}
		}
	});

	$(document).on('click', 'main, .nav-wrapper a:not(.nav-burger)', function() {
		const subnav = $(this).siblings('.nav-subitems');
		if (!subnav.length) {
			$('.nav').removeClass('nav--opened');
		}
	}).on('click', '.siteswapper-button', function() {
		$(this).closest('.siteswapper').addClass('siteswapper--extended');
	});

});
